<template>
  <div class="order-list">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-size:25px;font-weight:bold;margin:0 10px;">订单列表</span>
      </div>
      <div class="search-box">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <!--          <el-form-item label="订单编号">-->
          <!--            <el-input v-model="searchForm.id" @change="onFilOrderList()" placeholder="请输入订单编号"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="商品ID">
                      <el-input v-model="searchForm.goodsId" @change="onFilOrderList()" placeholder="请输入商品ID"
                                clearable></el-input>
                    </el-form-item>-->
          <el-form-item label="商品名称">
            <el-input v-model="searchForm.goodsName" @change="onFilOrderList()" placeholder="请输入商品名称"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="房间名称">
            <el-input v-model="searchForm.roomName" @change="onFilOrderList()" placeholder="请输入房间名称"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="客户手机号">
            <el-input v-model="searchForm.phoneNumber" @change="onFilOrderList()" placeholder="请输入手机号"
                      clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="display:flex;align-items: center">
          <p style="margin-top:1px;margin-bottom:1px;margin-right:5px">下单时间</p>
          <el-date-picker
              v-model="edi_time"
              type="daterange"
              :clearable="true"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="margin-left:10px"
              @change="onFilOrderList()">
          </el-date-picker>
        </div>
      </div>
      <div style="display:flex;align-items:center">
        <p v-for="(d,index) in liState" :key="`dd${index}`"
           @click="onXz(d.value)" :class="xzState===d.value ? 'xzMs1' : 'xzMs'" style="margin:10px;">{{ d.label }}</p>
      </div>
      <el-table :data="liOrder" class="tab_order" style="width: 100%">
        <!--        <el-table-column prop="id" label="订单编号" width="180"></el-table-column>-->
        <el-table-column prop="orderTypeName" label="订单类型" width="100"></el-table-column>
        <el-table-column prop="orderStatusName" label="订单状态" width="100"></el-table-column>
        <el-table-column prop="times" label="下单时间" width="150"></el-table-column>
        <el-table-column prop="tradeState" label="支付状态" width="120"></el-table-column>
        <el-table-column prop="transactionId" label="支付流水号" width="120"></el-table-column>
        <el-table-column label="商品名称" width="auto">
          <template slot-scope="scope">
            <div v-html="scope.row.orderSkuName.replace(/、/g, '<br>')"></div>
          </template>
        </el-table-column>
        <!--        <el-table-column prop="goodsId" label="商品ID" width="auto"></el-table-column>-->
        <el-table-column prop="money" label="订单金额" width="80">
          <template slot-scope="scope">
            ¥{{ scope.row.money.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="moneyPaid" label="实付金额" width="100">
          <template slot-scope="scope">
            ¥{{ scope.row.moneyPaid.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" label="房间名称" width="auto"></el-table-column>
        <el-table-column prop="appTime" label="预约时间" width="auto"></el-table-column>
        <el-table-column prop="userName" label="客户名称" width="auto"></el-table-column>
        <el-table-column prop="phoneNumber" label="客户手机号" width="auto"></el-table-column>
        <!--        <el-table-column prop="status" label="订单状态" width="100">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-tag v-if="scope.row.status === 0" size="small">待支付</el-tag>-->
        <!--            <el-tag v-else-if="scope.row.status === 1" size="small" type="success">已支付</el-tag>-->
        <!--            <el-tag v-else-if="scope.row.status === 2" size="small" type="info">已完成</el-tag>-->
        <!--            <el-tag v-else-if="scope.row.status === 3" size="small" type="danger">已取消</el-tag>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div style="text-align: left;">
              <!--              <el-button v-if="scope.row.orderStatusId===1 || scope.row.orderStatusId===2"
                                       @click="upState(scope.row, 'w')" type="text" size="small"
                                       style="color:#1677FF;font-size: 14px">关闭
                            </el-button>
                            <el-button v-if="scope.row.orderStatusId===3 || scope.row.orderStatusId===4|| scope.row.orderStatusId===5"
                                       @click="upState(scope.row, 'w')" type="text" size="small"
                                       style="color:#1677FF;font-size: 14px">退款
                            </el-button>
                            <el-button v-if="scope.row.orderStatusId===5"
                                       @click="upState(scope.row, 'w')" type="text" size="small"
                                       style="color:#1677FF;font-size: 14px">取消
                            </el-button>-->
              <el-button @click="viewOrder(scope.row, 'r')" type="text" size="small"
                         style="color:#4B5563;font-size: 14px">查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name:'orderList',
  data() {
    return {
      xzState:0,
      liState:[],
      searchForm:{
        id:'',
        phoneNumber:'',
        goodsId:'',
        goodsName:'',
        roomName:''
      },
      edi_time:'',
      liOrder:[],
      page:1,
      pageSize:10,
      total:0
    };
  },
  methods:{
    onXz(xzId) {
      this.xzState = xzId;
      this.onFilOrderList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUserOrderList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUserOrderList();
    },
    upState() {

    },
    viewOrder(order) {
      console.log('查看订单详情:',order);
      // 跳转到订单详情页面
      this.$router.push(`/home/orderListSon?id=${order.id}`);
    },
    cancelOrder(orderId) {
      this.$confirm('确定要取消该订单吗?','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(() => {
        console.log('取消订单:',orderId);
        // 实际项目中这里会调用API取消订单
        this.$message({type:'success',message:'订单已取消'});
      }).catch(() => {
        this.$message({type:'info',message:'已取消操作'});
      });
    },
    getOrderStatusList() {
      const params = {
        page:1,
        pageSize:30,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getOrderStatusList,params,headers).then(res => {
        console.log("getOrderStatusList",res.data.data);
        let li_d = res.data.data.list;
        if (li_d && li_d.length > 0) {
          let l = [{label:"全部订单",value:0}];
          for (let i = 0; i < li_d.length; i++) {
            l.push({label:li_d[i]["name"],value:li_d[i]['id']});
          }
          this.liState = l;
        } else {
          this.liState = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品信息失败");
        }
      });
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes());
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m;
    },
    initOrder(data) {
      let l_d = [];
      for (let i = 0; i < data.length; i++) {
        let d = data[i];
        let d_d = {
          id:d['id'],
          orderStatusId:d['orderStatusId'], /*订单状态Id*/
          orderTypeName:"", /*订单类型*/
          orderStatusName:d['orderStatus']['name'], /*订单状态*/
          tradeState:d['orderStatus']['description'], /*微信支付状态*/
          transactionId:d['transactionId'], /*微信支付订单号*/
          money:d['money'] / 100, /*金额*/
          moneyPaid:d['realMoney'] / 100, /*实付金额*/
          goodsId:"", /*商品id*/
          orderSkuName:"", /*商品名称*/
          roomName:"", /*空间名称*/
          userName:"", /*客户名称*/
          phoneNumber:"", /*客户手机号*/
          appTime:"", /*预约时间*/
          times:this.timestampToTime(d['timestamp'] * 1000)
        };
        if (d['appoint']) {
          let devArea = "";
          let d_r = d['appoint'];
          if (d_r['room']) {
            devArea = d_r['room']['name'];
            if (d_r['room']['floor']) {
              devArea = d_r['room']['floor']['name'] + "-" + d_r['room']['name'];
              if (d_r['room']['floor']['building']) {
                devArea = d_r['room']['floor']['building']['name'] + "-" + d_r['room']['floor']['name'] + "-" + d_r['room']['name'];
              }
            }
          } else if (d_r['floor']) {
            devArea = d_r['floor']['name'];
            if (d_r['floor']['building']) {
              devArea = d_r['floor']['building']['name'] + "-" + d_r['floor']['name'];
            }
          }
          if (d['appoint']['name'] !== devArea) {
            d_d['roomName'] = `${d['appoint']['name']}-${devArea}`;
          } else {
            d_d['roomName'] = `${d['appoint']['name']}`;
          }
        }
        let orderSkuName = "";
        if (d['orderSku'] && d['orderSku'].length > 0) {
          for (let j = 0; j < d['orderSku'].length; j++) {
            if (d['orderSku'][j]['goodsSku'] && d['orderSku'][j]['goodsSku']['goods']) {
              orderSkuName += d['orderSku'][j]['goodsSku']['goods']['name'] + "-" + d['orderSku'][j]['goodsSku']['skuName'] + "、";
            }
          }
        }
        d_d['orderSkuName'] = orderSkuName;
        if (d['orderType']) {
          d_d["orderTypeName"] = d['orderType']['name']; /*订单类型*/
        }
        if (d['appoint']) {
          d_d["appTime"] = `${d['appoint']["beginExpDate"]} - ${d['appoint']["endExpDate"]}`;
        }
        if (data[i]["user"]) {
          if (data[i]['user']['phoneNumber']) {
            d_d["phoneNumber"] = data[i]['user']['phoneNumber'];
          } else {
            d_d["phoneNumber"] = data[i]['user']['applyNumber'];
          }
          if (data[i]['user']['name']) {
            d_d["userName"] = data[i]['user']['name'];
          } else if (data[i]['user']["nickName"]) {
            d_d['userName'] = data[i]['user']["nickName"];
          } else if (data[i]['user']["userName"]) {
            d_d['userName'] = data[i]["userName"];
          }
        } else {
          if (data[i]["customNumber"]) { /*手机号*/
            d_d['phoneNumber'] = data[i]["customNumber"];
          }
          if (data[i]["name"]) { /*用户名*/
            d_d['userName'] = data[i]["name"];
          } else if (data[i]["nickName"]) {
            d_d['userName'] = data[i]["nickName"];
          } else if (data[i]["userName"]) {
            d_d['userName'] = data[i]["userName"];
          }
        }
        l_d.push(d_d);
      }
      this.liOrder = l_d;
    },
    onFilOrderList() {
      this.page = 1;
      this.getUserOrderList();
    },
    getUserOrderList() {
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        projectId:localStorage.getItem("projectId")
      };
      if (this.xzState) { /*订单状态*/
        params['orderStatusId'] = [this.xzState];
      }
      if (this.searchForm.id) { /*订单编号*/
        params['id'] = this.searchForm.id;
      }
      if (this.searchForm.phoneNumber) { /*手机号*/
        params['phoneNumber'] = this.searchForm.phoneNumber;
      }
      if (this.searchForm.goodsId) { /*商品id*/
        params['goodsId'] = this.searchForm.goodsId;
      }
      if (this.searchForm.goodsName) { /*商品名称*/
        params['goodsName'] = this.searchForm.goodsName;
      }
      if (this.searchForm.roomName) { /*房间名称*/
        params['roomName'] = this.searchForm.roomName;
      }
      if (this.edi_time) { /*订单时间*/
        params['fromTime'] = parseInt(new Date(this.edi_time[0] + 'T00:00:00').getTime() / 1000);
        params['toTime'] = parseInt(new Date(this.edi_time[1] + 'T00:00:00').getTime() / 1000) + 86400; /*结尾+1天*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getUserOrderList,params,headers).then(res => {
        console.log("getUserOrderList",res.data.data);
        let li_d = res.data.data.list;
        this.total = res.data.data.total;
        if (li_d && li_d.length > 0) {
          this.initOrder(li_d);
        } else {
          this.liOrder = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取订单信息失败");
        }
      });
    }
  },
  mounted() {
    this.getOrderStatusList();
    this.getUserOrderList();
  }
};
</script>

<style scoped>
.order-list {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
}

.search-box {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.clearfix {
  display: block;
}

.xzMs1 {
  color: blue;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid blue;
}

.xzMs {
  color: #8f8f94;
  font-size: 18px;
}

.tab_order {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/orderList.vue